/**
 * AD-531. Прошёл ли срок регистрации — зеркало серверного правила
 * (`event-registration.policy.ts`, `deadlinePassed`): срока нет — запись не
 * закрыта; момент, РАВНЫЙ сроку, ещё принимается (строгое `>`).
 *
 * Зеркало только подсказывает экрану, какую кнопку не показывать; решает
 * сервер. Часы зрителя могут отставать, поэтому экраны принимают отказ
 * `REGISTRATION_DEADLINE_PASSED` как окончательный и без этой функции.
 *
 * Нечитаемый срок считается отсутствующим: закрыть запись по мусору значило бы
 * отнять у человека кнопку, по которой сервер бы записал.
 */
export const isRegistrationDeadlinePassed = (
  deadline: Date | string | null | undefined,
  now: Date,
): boolean => {
  if (!deadline) return false;
  const at = (
    deadline instanceof Date ? deadline : new Date(deadline)
  ).getTime();
  if (Number.isNaN(at)) return false;
  return now.getTime() > at;
};
